import { apiFetch } from '../../../utility'

export function getPrivacyPolicy(dispatch) {
    const url = `api/Portal/GetPrivacyPolicy`;
    return apiFetch(dispatch, url);
}